//REACT
import React, {Fragment, useContext, useRef} from 'react';

//MUI COMPONENTS
import {
    makeStyles,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Grid,
    ButtonBase,
    Button,
    withStyles,
    TextField,
    InputAdornment,
    LinearProgress,
    Fade,
    Link,
    Avatar,
    Container,
    Box,
    useMediaQuery,
    useTheme
} from '@material-ui/core';

// Font Awesome Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileAlt, faBook, faPoundSign, faSync, faUndoAlt} from '@fortawesome/free-solid-svg-icons'

// Custom Contexts
import {MarketDataContext} from '../contexts/MarketDataContext';

// Custom Components
import Collapsable from './Collapsable';
import CollapsableLightBlue from './CollapsableLightBlue';
import CollapsableProperty from './CollapsableProperty';


const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        padding:theme.spacing(2),
    },
        image:{
            backgroundColor:'transparent',
            // ESPC no longer honours the &width=&height= params in the image URL,
            // so it returns the full-resolution image. Constrain it in CSS to the
            // intended box regardless of the source dimensions.
            '& img':{
                display:'block',
                width:360,
                height:240,
                maxWidth:'100%',
                objectFit:'cover'
            },
            [theme.breakpoints.down("sm")]: {
                marginBottom:10,
                width:'100%',
                '& img':{
                    width:'100%',
                    height:200
                }
            }
        },
    propertyPaper: {
        padding: theme.spacing(3),
        textAlign: 'left',
        color: theme.palette.text.secondary,
        backgroundColor:'#f6f6f6',
        marginBottom: '15px',

    },
    propertyTitleMain:{

        fontSize: 40,
        fontWeight: 'bold',
        color:theme.palette.primary.main,
        [theme.breakpoints.down("sm")]: {
            fontSize:24,
            marginBottom:10
        },
    },
    propertyInfo:{
        fontFamily: "Cabin",
        fontSize: 24,
        fontWeight: 'normal',
        color:theme.palette.text.secondary,
            [theme.breakpoints.down("sm")]: {
                fontSize:18
            }
    },
     labelBold:{
        fontWeight:'bold'
     },
    propertyBodyText:{
        marginTop:'10px',
        fontFamily:"Cabin",
        color:'#565656',
        fontSize:21,
        [theme.breakpoints.down("sm")]: {
            fontSize:18
        },
        '& .orderedList':{

        },
        '& .blueBold':{
            color:theme.palette.primary.main,
            fontWeight:'bold'
        },
        '& .blueBoldItalic':{
            color:theme.palette.primary.main,
            fontWeight:'bold',
            fontStyle:'italic'
        }
    },
    downloadButton:{
        borderRadius:0,
        backgroundColor:'#FFFFFF',
        fontSize:12,
        fontWeight:500,
        color:theme.palette.primary.main,

        marginRight:20,
        textAlign:'left',
        justifyContent:'left',
        '& .AvatarCircle':{
            width:18,
            height:18,
            fontSize:11,
            backgroundColor:theme.palette.primary.main,
            color:'#FFFFFF'
        },
        '& .downloadButtonIcon':{
            fontSize:11,
        },
        '&:hover':{
            backgroundColor:theme.palette.primary.main,
            color:'#FFFFFF',
            '& .AvatarCircle':{
                color:theme.palette.primary.main,
                backgroundColor:'#FFFFFF'
            },
        },
        [theme.breakpoints.down("sm")]: {
            marginBottom:10
        },
        width:230,
        height:40
    },
    bodyTextContainer:{
        marginTop:30,
        marginBottom:30,
        padding:'10px',

    },
    propertyDetailsDataContainer:{
        [theme.breakpoints.down("sm")]: {
            marginBottom:20
        },
    },
    headerBox:{
        paddingTop:'50px',
        padding:theme.spacing(2),
        paddingBottom:30
    },
    sectionText:{
        fontSize:21,
        [theme.breakpoints.down("sm")]: {
            fontSize:18,
            lineHeight:1.5
        },
    },
    sectionTextBlue:{
        fontSize:'21px',
        color:theme.palette.primary.main,
        fontWeight:'bold',
        fontFamily:"Cabin",
        [theme.breakpoints.down("sm")]: {
            fontSize:18,
            lineHeight:1.5
        },
    },
    boxBlueLabel:{
        fontSize:28,
        color:theme.palette.primary.main,
        fontWeight:'bold',
        fontFamily:"Cabin",
        textAlign:'center',
        [theme.breakpoints.down("sm")]: {
            fontSize:21,
        },
    },
    boxLabel:{
        fontSize:18,
        fontFamily:"Cabin",
        textAlign:'center',
        [theme.breakpoints.down("sm")]: {
            fontSize:16,
        },
    },
    infoBox:{
        borderRadius: 0,
        paddingTop:20,
        paddingBottom:20,
        paddingRight:10,
        paddingLeft:10,
        boxShadow:'10px',
    },
    statsGrid:{
        marginTop:'20px',
        marginBottom:'20px'
    },
    budgetInput:{
        marginTop:10,
        marginBottom:10,
    },
    budgetInputInput:{
        fontSize:'16px',
        color:theme.palette.primary.main,
        fontWeight:'bold',
        fontFamily:"Cabin",
    },
    totalsBox:{
        backgroundColor:'#90d3ff',
        padding:'15px'
    },
    totalsBoxWhite:{
        fontFamily:"Cabin",
        fontSize:'21px',
        color:'#FFFFFF'
    },
    totalsBoxBlue:{
        fontFamily:"Cabin",
        fontSize:'21px',
        fontWeight:'bold',
        color:theme.palette.primary.main
    },
    gotoButton:{
        backgroundColor:theme.palette.primary.main,
        fontSize:16,
        width:325,
        lineHeight:"45px",
        fontWeight:600,
        color:'#FFFFFF',
        marginRight:10,
        borderRadius:0,
        '& .AvatarCircle':{
            width:'20px',
            height:'20px',
            fontSize:12,
            color:theme.palette.primary.main,
            backgroundColor:'#FFFFFF'
        },
        '& .gotoButtonIcon':{
            fontSize:12,
        },
        '&:hover':{
            color:theme.palette.primary.main,
            backgroundColor:'#FFFFFF',
            '& .AvatarCircle':{
                width:'25px',
                height:'25px',
                fontSize:12,
                backgroundColor:theme.palette.primary.main,
                color:'#FFFFFF'
            },
        },
        '&:disabled':{
            color:'#FFFFFF',
            opacity: 0.5
        },
        [theme.breakpoints.down("sm")]: {
            marginBottom:10
        },
    },
    loading:{
      paddingTop:70,
        color:theme.palette.primary.main
    },
    backToAllProperties:{
        fontFamily:"Cabin",
        fontWeight:'bold'
    },
    propertiesContainer:{
        paddingTop:30
    },
    OffersTableContainer:{
        paddingRight:220
    },
    formContainer:{
        marginLeft:-24,
        marginRight:-24
    }
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#90d3ff',
        color: theme.palette.primary.main,
        fontSize: 24,
        fontFamily:"Cabin",
        lineHeight:'65px',
        fontWeight: 600,
        paddingTop:0,
        paddingBottom:0,
        paddingLeft:40,
        [theme.breakpoints.down("sm")]: {
            lineHeight:1.5,
            fontSize:12,
            paddingLeft:10,
            paddingTop:5,
            paddingBottom:5,
        }

    },
    body: {
        fontSize: 18,
        fontWeight: 700,
        paddingLeft:20,
        [theme.breakpoints.down("sm")]: {
            fontSize:10
            }

    },
}))(TableCell);

const StandardTableCell = withStyles((theme) => ({
    body: {
        fontSize: 18,
        fontFamily:"Cabin",
        paddingLeft:40,
        [theme.breakpoints.down("sm")]: {
            fontSize:10,
            paddingLeft:10
        }

    },
}))(TableCell);


const UnderHeaderCell = withStyles((theme) => ({
    head: {
        fontSize: 18,
        "fontWeight": 700,
    },
    body: {
        fontSize: 18,
        paddingLeft:40,
        "fontWeight": 700,
        [theme.breakpoints.down("sm")]: {
            fontSize:10,
            paddingLeft:10
        }
    },
}))(TableCell);

const HightlightTableCell = withStyles((theme) => ({
    root: {
        backgroundColor: '#dedede',
        color: theme.palette.primary.main,
        paddingLeft:40,
        [theme.breakpoints.down("sm")]: {
            fontSize:10,
            paddingLeft:10
        }

    },
    body: {
        fontSize: 16,
        fontFamily:"Cabin",
        "fontWeight": 'bold',
        [theme.breakpoints.down("sm")]: {
            fontSize:10,
            paddingLeft:10
        }
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        paddingLeft:40,
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
    cell:{
        paddingLeft:20
    }
}))(TableRow);



var apiUrl = process.env.REACT_APP_API_URL_START + window.location.hostname.substr(window.location.hostname.split('.')[0].length) + process.env.REACT_APP_API_URL_END;

function MarketDataTable() {
    const context = useContext(MarketDataContext);
    const classes = useStyles();


    const onFormChange = (e) => {
        context.updateData(e.target.id,e.target.value);
    };

    const onResetPress = (e) =>{
        context.resetData();
    }

    const doUpdatePress = (e) => {
        context.doCalculate();
    }


    const divRef = useRef();


    /*
    { context.pipData.sqmP > 0 ?
        <Typography className={classes.propertyInfo}> (
            <span className={classes.labelBold}>{(new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
            })).format(context.pipData.sqmP)}</span>
            /sqm)</Typography>
        : ''
    }
       */
    const { innerWidth: width, innerHeight: height } = window;
    const miniMobile = (width < 700);
    const bigWidth = (width > 900);
    return (



        <Fragment>
            <Container>
            {context.isLoading ?
                <div className={classes.loading}><Typography variant="h4" align="center">Loading...</Typography></div>
                :
                <Fragment>

                    <div className={classes.headerBox}>
                        <Link className={classes.backToAllProperties} href="/home">&lt; Back to all properties</Link>
                    </div>
                    <Paper className={classes.propertyPaper} style={{width:'100%'}} square={true}>
                        {context.pipData.thumb &&
                        <>
                            {miniMobile ?
                                <ButtonBase className={classes.image} href={"/pip/" + context.pipData.fcase_id}>
                                    <img width="100%" src={context.pipData.thumb + '&width=300&height=200'} alt=""/>
                                </ButtonBase>
                                :
                                <></>
                            }
                        </>
                        }
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm>

                                <Box
                                    display="flex"
                                    flexWrap="wrap"
                                    height={bigWidth ? 240 : '100%'}
                                    className={classes.propertyDetailsDataContainer}
                                >

                                    <Box alignSelf="flex-start" >



                                        <div>

                                            <Typography className={classes.propertyTitleMain}>
                                            {context.pipData.property_address}
                                        </Typography>


                                        <Typography className={classes.propertyInfo}>
                                            {context.pipData.price_qualifier_label && <>{context.pipData.price_qualifier_label}: </>} <span className={classes.labelBold}>{context.outputCurrency(context.pipData.askingPrice)}</span>
                                        </Typography>
                                        { context.pipData.hrValue > 0 &&
                                            <Typography className={classes.propertyInfo}>
                                                Home Report Value: <span className={classes.labelBold}>{context.outputCurrency(context.pipData.hrValue)}</span>
                                            </Typography>
                                        }
                                        { context.pipData.sqm > 0 ? <Typography className={classes.propertyInfo}>Internal Area: <span className={classes.labelBold}>{context.pipData.sqm} sqm</span></Typography> : ''}

                                        {context.rosData.titleNo !== undefined ?
                                            <Typography className={classes.propertyInfo}>
                                                Title No. <span className={classes.labelBold}>{context.rosData.titleNo}</span>
                                                <br/>
                                            </Typography>: ''
                                        }
                                        {context.rosData.lastPurchasedDate !== undefined && context.rosData.lastPurchasedDate !== null ?
                                            <Typography className={classes.propertyInfo}>
                                                Last purchased: {context.outputDate(context.rosData.lastPurchasedDate)}
                                                {context.rosData.purchasePrice !== undefined  && context.rosData.purchasePrice !== null ?
                                                    <>
                                                        <span> for {(new Intl.NumberFormat('en-GB', {
                                                        style: 'currency',
                                                        currency: 'GBP',
                                                        minimumFractionDigits: 0,
                                                        maximumFractionDigits: 0
                                                        })).format(context.rosData.purchasePrice)}</span>
                                                    </>
                                                    : ''}
                                            </Typography> : ''}
                                        </div>
                                    </Box>
                                    <Box alignSelf="flex-end" >
                                        {context.pipData.hr_cdn_id > 0 ?

                                            <Button variant="outlined" className={classes.downloadButton} startIcon={<Avatar className="AvatarCircle"><FontAwesomeIcon className="downloadButtonIcon" icon={faFileAlt} /></Avatar>} href={apiUrl+'/file/'+context.pipData.hr_cdn_id+'/homereport'} >
                                                Download Home Report
                                            </Button>
                                            :
                                            ''
                                        }
                                        {context.pipData.brochure_cdn_id > 0 ?
                                            <Button variant="outlined" className={classes.downloadButton} href={apiUrl+'/file/'+context.pipData.brochure_cdn_id+'/brochure'} startIcon={<Avatar className="AvatarCircle"><FontAwesomeIcon className="downloadButtonIcon" icon={faBook} /></Avatar>}>
                                                Download Schedule
                                            </Button>
                                            :
                                            ''
                                        }
                                        <Button variant="outlined" className={classes.downloadButton} href={apiUrl+'/fcase/'+context.pipData.fcase_id+'/budgetplanner/download'} target="_blank"  startIcon={<Avatar className="AvatarCircle"><FontAwesomeIcon className="downloadButtonIcon" icon={faPoundSign} /></Avatar>}>
                                            Download Budget Planner
                                        </Button>
                                    </Box>
                                </Box>

                            </Grid>
                            {context.pipData.thumb &&
                            <Grid item>
                                {miniMobile ?
                                    <></>
                                    :
                                    <ButtonBase className={classes.image} href={"/pip/" + context.pipData.fcase_id}>
                                        <img src={context.pipData.thumb + '&width=360&height=240'} alt=""/>
                                    </ButtonBase>
                                }
                            </Grid>
                            }
                        </Grid>
                    </Paper>
                    <div className={classes.bodyTextContainer}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={8}>
                                <Typography className={classes.propertyBodyText}>
                                    Offering at a closing date successfully is an exercise in trying to out-think the competition.
                                    <br/><br/>
                                    <span className="blueBold">What will the other notes of interest Offer?</span>
                                    <br/><br/>
                                    Of course we don't know but our experience tells us that the others will arrive at their Offer by being influenced by three psychological  drivers...
                                    <ol className="orderedList">
                                        <li>
                                            The historians  will be guided by past prices.
                                        </li>
                                        <li>
                                            The mathematicians will offer a percentage over asking price or valuation.
                                        </li>
                                        <li>
                                            People always offer in units of £2,500... and some change.
                                        </li>
                                    </ol>
                                    <br/>
                                    <span className="blueBold">Let's look at these drivers in detail:</span>

                                </Typography>
                            </Grid>
                        </Grid>
                    </div>



                    <Collapsable title={"1. Historians will base their offer on these statistics:"}>
                        <Grid container spacing={2} >
                            <Grid item xs={12} sm={7}>
                                <Typography className={classes.sectionText}>
                                    The competitors driven by historical data will look at how similar properties have performed on the market in the past in order to formulate their Offer.
                                </Typography>
                                <br/>
                                <Typography className={classes.sectionTextBlue}>
                                    Let's look at how similar properties have performed in the past:
                                </Typography>
                            </Grid>
                        </Grid>

                        <Grid container spacing={3} className={classes.statsGrid}>
                            <Grid item xs={12} sm={4}>
                                <Paper elevation={3} variant="outlined" className={classes.infoBox}>
                                    <div className={classes.boxBlueLabel}>
                                        {context.outputCurrency(context.stats.avgSelling)}
                                    </div>
                                    <div className={classes.boxLabel}>
                                        Avg Sold Price
                                    </div>
                                </Paper>
                            </Grid>
                            {
                                context.stats.richMarketData &&
                                <>
                                    <Grid item xs={12} sm={4}>
                                        <Paper elevation={3} variant="outlined" className={classes.infoBox}>
                                            <div className={classes.boxBlueLabel}>
                                                {context.stats.avgOverHr.toFixed(2).toLocaleString()}%
                                            </div>
                                            <div className={classes.boxLabel}>
                                                {context.stats.avgOverHr >=0 ? <span>Over</span> : <span>Under</span>} Home Report (HR) Value
                                            </div>
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Paper elevation={3} variant="outlined" className={classes.infoBox}>
                                            <div className={classes.boxBlueLabel}>
                                                {context.stats.avgOverAsking.toFixed(2).toLocaleString()}%
                                            </div>
                                            <div className={classes.boxLabel}>
                                                {context.stats.avgOverAsking >=0 ? <span>Over</span> : <span>Under</span>}  Asking Price
                                            </div>
                                        </Paper>
                                    </Grid>
                                    </>
                                    }
                        </Grid>
                        <Grid container className={classes.statsGrid} justifyContent="center" alignItems="center" spacing={3} style={{marginTop:-20}}>
                            {
                                context.stats.richMarketData &&
                                    <>
                                    <Grid item xs={12} sm={4}>
                                        <Paper elevation={3} variant="outlined" className={classes.infoBox}>
                                            <div className={classes.boxBlueLabel}>
                                                {context.stats.avgDays}
                                            </div>
                                            <div className={classes.boxLabel}>
                                                Average Number of Days to Sell
                                            </div>
                                        </Paper>
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <Paper elevation={3} variant="outlined" className={classes.infoBox}>
                                            <div className={classes.boxBlueLabel}>
                                                {
                                                    (new Intl.NumberFormat('en-GB', {
                                                        style: 'currency',
                                                        currency: 'GBP',
                                                        minimumFractionDigits: 0,
                                                        maximumFractionDigits: 0
                                                    })).format(context.stats.avgSqm)
                                                }
                                            </div>
                                            <div className={classes.boxLabel}>
                                                Average price per sqm
                                            </div>
                                        </Paper>
                                    </Grid>

                                        <Grid item xs={12} sm={4}>
                                            <Paper elevation={3} variant="outlined" className={classes.infoBox}>
                                                <div className={classes.boxBlueLabel}>
                                                    {context.stats.maxOverHr.toFixed(2).toLocaleString()}%
                                                </div>
                                                <div className={classes.boxLabel}>
                                                    Highest % achieved over HR
                                                </div>
                                            </Paper>
                                        </Grid>
                                </>
                            }
                        </Grid>

                        <div className={classes.propertiesContainer}>
                        {context.sales.slice().reverse().map((sale, index) => (
                            <CollapsableProperty property={sale} key={index}/>
                        ))}
                        </div>


                    </Collapsable>

                    <Collapsable title={"2. Mathematicians will use these figures:"}>
                        <Grid container spacing={2} >
                            <Grid item xs={12} sm={7}>
                                <Typography className={classes.propertyBodyText}>


                                    The competitors driven by mathematical data will apply a percentage over the asking price, or a percentage over the home report value to work out what to Offer.

                                    <br/><br/>
                                    <span className="blueBold">Let's look at possible offers based on percentages:</span>

                                </Typography>
                            </Grid>
                        </Grid>
                        <br/><br/>
                        <Grid container spacing={2} >
                            <Grid item xs={12} sm={9}>
                        <TableContainer component={Paper} square={true}>
                            <Table className={classes.table} >
                                <TableHead key="thead">
                                    <TableRow>

                                        <StyledTableCell>
                                            % Uplift
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            Over Asking Price
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            Over HR Valuation
                                        </StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow key="top_res">


                                        <TableCell></TableCell>
                                        <UnderHeaderCell>{context.outputCurrency(context.pipData.askingPrice)} (actual)</UnderHeaderCell>
                                        <UnderHeaderCell>{context.outputCurrency(context.pipData.hrValue)} (actual)</UnderHeaderCell>

                                    </TableRow>
                                    {context.tableMap ?
                                        context.tableMap.map((upVal,index) => (
                                            <StyledTableRow  key={index} >

                                                {upVal.upliftHighlight === true ?
                                                    <>
                                                        <HightlightTableCell>
                                                            {upVal.uplift.toFixed(2).toLocaleString()}%
                                                        </HightlightTableCell>
                                                        <HightlightTableCell>
                                                            {
                                                                upVal.askingPriceUplift > 0 ?
                                                                    <>

                                                                        context.outputCurrency(upVal.askingPriceUplift)%
                                                                    </>
                                                                    :
                                                                    <span>
                                                            Offer based on averages
                                                        </span>
                                                            }
                                                        </HightlightTableCell>
                                                        <HightlightTableCell>
                                                            {context.outputCurrency(upVal.hrValueUplift)}
                                                        </HightlightTableCell>
                                                    </>
                                                    :
                                                    <>
                                                        <StandardTableCell>
                                                            {upVal.uplift.toFixed(2).toLocaleString()}%
                                                        </StandardTableCell>
                                                        <StandardTableCell>
                                                            {context.outputCurrency(upVal.askingPriceUplift)}
                                                        </StandardTableCell>
                                                        <StandardTableCell>
                                                            {context.outputCurrency(upVal.hrValueUplift)}
                                                        </StandardTableCell>
                                                    </>
                                                }


                                            </StyledTableRow >
                                        )) : <TableRow></TableRow>
                                    }

                                </TableBody>
                            </Table>
                        </TableContainer>
                                <br/>
                                <Typography className={classes.propertyBodyText}>
                                    Based on these <span className="blueBoldItalic">historical</span> averages you could be looking to offer at least

                                    {context.tableMap ?
                                            context.tableMap.map((upVal,index) => (
                                                <>
                                                    {
                                                        upVal.upliftHighlight === true &&
                                                        <span className="blueBold"> {context.outputCurrency(upVal.hrValueUplift)} </span>
                                                    }
                                                </>
                                            ))
                                                :<></>
                                    }
                                    or above.


                                </Typography>


                            </Grid>
                        </Grid>
                    </Collapsable>

                    <Collapsable title={"3. Every Offer will be in units of £2,500:"}>
                        <Grid container spacing={2} >
                            <Grid item xs={12} sm={7}>
                                <Typography className={classes.sectionText}>
                                    People will often offer in units of £2,500, so let's look at some offer figures based on these £2,500 units:
                                </Typography>
                            </Grid>
                        </Grid>
                        <br/><br/>
                        <Grid container spacing={2} >
                            <Grid item xs={12} sm={9}>
                                <TableContainer component={Paper} >
                                    <Table className={classes.table} square={true} >
                                        <TableHead key="thead">
                                            <TableRow>
                                                <StyledTableCell fontWeight="fontWeightMedium">
                                                    £2.5k Incremental Uplift
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    Over HR Valuation
                                                </StyledTableCell>


                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow key="top_res">


                                                <UnderHeaderCell></UnderHeaderCell>
                                                <UnderHeaderCell>{context.outputCurrency(context.pipData.hrValue)}</UnderHeaderCell>

                                            </TableRow>
                                            {context.tableMap ?
                                                context.tableMap.map((upVal,index) => (
                                                    <>
                                                    {
                                                        upVal.magneticNumber !== '' &&
                                                            <StyledTableRow key={index}>

                                                                {upVal.magneticHightlight === true ?
                                                                    <>
                                                                        <HightlightTableCell>
                                                                            {upVal.magneticNumber !== '' ? upVal.magneticNumber.toLocaleString() : ''}
                                                                        </HightlightTableCell>
                                                                        <HightlightTableCell>
                                                                            {context.outputCurrency(upVal.magneticNumberOffer)}
                                                                        </HightlightTableCell>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <StandardTableCell>
                                                                            {upVal.magneticNumber !== '' ? upVal.magneticNumber.toLocaleString() : ''}
                                                                        </StandardTableCell>
                                                                        <StandardTableCell>
                                                                            {context.outputCurrency(upVal.magneticNumberOffer)}
                                                                        </StandardTableCell>
                                                                    </>
                                                                }

                                                            </StyledTableRow>
                                                    }
                                                    </>
                                                )) : <TableRow></TableRow>
                                            }

                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <br/>
                                <Typography className={classes.propertyBodyText}>
                                Based on these <span className="blueBoldItalic">historical</span> averages you would be looking to offer anywhere between

                                    <span className="blueBold"> {context.outputCurrency(context.magneticHighlights[0])} - {context.outputCurrency(context.magneticHighlights[1])} </span>
                                or above... and some change.
                                </Typography>
                            </Grid>
                        </Grid>
                    </Collapsable>


                    <CollapsableLightBlue title={"Budget Planner"}>
                        <Grid container spacing={2} >
                            <Grid item xs={12} sm={7}>
                                <Typography className={classes.sectionText}>
                                    Let's revisit the Budgetplan and see what you can afford to offer.
                                    <br/><br/>
                                    Feel free to adjust the sale, purchase and mortgage figures, then press update calculations to show the impact these changes make to the bottom line.
                                </Typography>
                                <br/>
                                <Typography className={classes.sectionTextBlue}>
                                    Don’t insert a mortgage figure above your agreement in principle or higher than the loan to valuation available - normally up to 95% of valuation (not price).
                                </Typography>
                            </Grid>
                        </Grid>

                        <Fade in={context.showProgressBar}>
                            <div className={classes.root}>
                                <LinearProgress variant="determinate" value={context.progressBarProgress} />
                            </div>
                        </Fade>

                        <Fade in={!context.showProgressBar} ref={divRef}>
                            <div className={classes.root} >
                                {context.budgetPlannerData.feeTotals !== undefined && context.budgetPlannerData.doSale &&
                                <>
                                    <div className={classes.formContainer}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} sm={6}>
                                            <Paper elevation={3} variant="outlined" className={classes.infoBox}>
                                                <form className={classes.root} noValidate autoComplete="off">
                                                    <div>
                                                        <TextField
                                                            id="formData.current_property_valuation"
                                                            onChange={onFormChange}
                                                            label="Sale Price"
                                                            value={
                                                                (new Intl.NumberFormat('en-GB', {
                                                                    style: 'decimal',
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                })).format(context.budgetPlannerData.formData.current_property_valuation)
                                                            }
                                                            fullWidth
                                                            InputProps={{
                                                                className: classes.budgetInputInput,
                                                                startAdornment: <InputAdornment
                                                                    position="start">&pound;</InputAdornment>,
                                                            }}
                                                            variant="outlined"
                                                            className={classes.budgetInput}
                                                        />
                                                    </div>
                                                    <div>
                                                        <TextField
                                                            id="formData.existing_mortgage"
                                                            onChange={onFormChange}
                                                            label="Outstanding Mortgage"
                                                            value={
                                                                context.budgetPlannerData.formData.existing_mortgage ?
                                                                    (new Intl.NumberFormat('en-GB', {
                                                                        style: 'decimal',
                                                                        minimumFractionDigits: 0,
                                                                        maximumFractionDigits: 0
                                                                    })).format(context.budgetPlannerData.formData.existing_mortgage) : ''
                                                            }
                                                            fullWidth
                                                            InputProps={{
                                                                className: classes.budgetInputInput,
                                                                startAdornment: <InputAdornment
                                                                    position="start">&pound;</InputAdornment>,
                                                            }}
                                                            variant="outlined"
                                                            className={classes.budgetInput}
                                                        />
                                                    </div>
                                                    <div>
                                                        <TextField
                                                            id="formData.second_mortgage"
                                                            onChange={onFormChange}
                                                            label="Any Other Loans"
                                                            value={
                                                                context.budgetPlannerData.formData.second_mortgage ? (new Intl.NumberFormat('en-GB', {
                                                                    style: 'decimal',
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                })).format(context.budgetPlannerData.formData.second_mortgage) : ''
                                                            }
                                                            fullWidth
                                                            InputProps={{
                                                                className: classes.budgetInputInput,
                                                                startAdornment: <InputAdornment
                                                                    position="start">&pound;</InputAdornment>,
                                                            }}
                                                            variant="outlined"
                                                            className={classes.budgetInput}
                                                        />
                                                    </div>
                                                    <div>
                                                        <TextField
                                                            id="estate_agency_fees"
                                                            label="Sale &amp; Estate Agency Fees"
                                                            value={
                                                                context.budgetPlannerData.feeTotals.saleFees ? (new Intl.NumberFormat('en-GB', {
                                                                    style: 'decimal',
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                })).format(context.budgetPlannerData.feeTotals.saleFees) : ''
                                                            }
                                                            fullWidth
                                                            InputProps={{
                                                                className: classes.budgetInputInput,
                                                                readOnly: true,
                                                                startAdornment: <InputAdornment
                                                                    position="start">&pound;</InputAdornment>,
                                                            }}
                                                            variant="outlined"
                                                            className={classes.budgetInput}
                                                        />
                                                    </div>
                                                    <div>
                                                        <TextField
                                                            id="sale_outlays"
                                                            label="Sale Outlays"
                                                            value={
                                                                context.budgetPlannerData.feeTotals.saleOutlays ? (new Intl.NumberFormat('en-GB', {
                                                                    style: 'decimal',
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                })).format(context.budgetPlannerData.feeTotals.saleOutlays) : ''
                                                            }
                                                            fullWidth
                                                            InputProps={{
                                                                className: classes.budgetInputInput,
                                                                readOnly: true,
                                                                startAdornment: <InputAdornment
                                                                    position="start">&pound;</InputAdornment>,
                                                            }}
                                                            variant="outlined"
                                                            className={classes.budgetInput}
                                                        />
                                                    </div>
                                                    <div>
                                                        <TextField
                                                            id="formData.additional_deductions"
                                                            label="Additional Deductions"
                                                            onChange={onFormChange}
                                                            value={
                                                                context.budgetPlannerData.formData.additional_deductions ? (new Intl.NumberFormat('en-GB', {
                                                                    style: 'decimal',
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                })).format(context.budgetPlannerData.formData.additional_deductions) : '0'
                                                            }
                                                            fullWidth
                                                            InputProps={{
                                                                className: classes.budgetInputInput,
                                                                startAdornment: <InputAdornment
                                                                    position="start">&pound;</InputAdornment>,
                                                            }}
                                                            variant="outlined"
                                                            className={classes.budgetInput}
                                                        />
                                                    </div>
                                                    <div>
                                                        <div className={classes.totalsBox}>

                                                            <Typography className={classes.totalsBoxWhite}>
                                                                { context.budgetPlannerData.saleBalance >=0 ? <>Surplus from Sale</> : <>Shortfall from Sale</> }
                                                            </Typography>
                                                            <Typography className={classes.totalsBoxBlue}>
                                                            {
                                                                context.budgetPlannerData.saleBalanceAbs ? (new Intl.NumberFormat('en-GB', {
                                                                    style: 'currency',
                                                                    currency: 'GBP',
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                })).format(context.budgetPlannerData.saleBalanceAbs) : ''
                                                            }
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                </form>
                                            </Paper>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Paper elevation={3} variant="outlined" className={classes.infoBox}>
                                                <form className={classes.root} noValidate autoComplete="off">
                                                    <div>
                                                        <TextField
                                                            id="formData.formPurchasePrice"
                                                            onChange={onFormChange}
                                                            label="Purchase Price"
                                                            value={
                                                                context.budgetPlannerData.formData.formPurchasePrice ? (new Intl.NumberFormat('en-GB', {
                                                                    style: 'decimal',
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                })).format(context.budgetPlannerData.formData.formPurchasePrice) : ''
                                                            }
                                                            fullWidth
                                                            InputProps={{
                                                                className: classes.budgetInputInput,
                                                                startAdornment: <InputAdornment
                                                                    position="start">&pound;</InputAdornment>,
                                                            }}
                                                            variant="outlined"
                                                            className={classes.budgetInput}
                                                        />
                                                    </div>
                                                    <div>
                                                        <TextField
                                                            id="formData.mortgageLevel"
                                                            onChange={onFormChange}
                                                            label="Mortgage Required"
                                                            value={
                                                                (new Intl.NumberFormat('en-GB', {
                                                                    style: 'decimal',
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                })).format(context.budgetPlannerData.formData.mortgageLevel)
                                                            }
                                                            fullWidth
                                                            InputProps={{
                                                                className: classes.budgetInputInput,
                                                                startAdornment: <InputAdornment
                                                                    position="start">&pound;</InputAdornment>,
                                                            }}
                                                            variant="outlined"
                                                            className={classes.budgetInput}
                                                        />
                                                    </div>
                                                    <div>
                                                        <TextField
                                                            id="purchase_fees"
                                                            label="Purchase Fees"
                                                            value={
                                                                context.budgetPlannerData.feeTotals.purchaseFees ? (new Intl.NumberFormat('en-GB', {
                                                                    style: 'decimal',
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                })).format(context.budgetPlannerData.feeTotals.purchaseFees) : ''
                                                            }
                                                            fullWidth
                                                            InputProps={{
                                                                className: classes.budgetInputInput,
                                                                readOnly: true,
                                                                startAdornment: <InputAdornment
                                                                    position="start">&pound;</InputAdornment>,
                                                            }}
                                                            variant="outlined"
                                                            className={classes.budgetInput}
                                                        />
                                                    </div>
                                                    <div>
                                                        <TextField
                                                            id="purchase_outlays"
                                                            label="Purchase Outlays"
                                                            value={
                                                                context.budgetPlannerData.feeTotals.purchaseOutlays ? (new Intl.NumberFormat('en-GB', {
                                                                    style: 'decimal',
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                })).format(context.budgetPlannerData.feeTotals.purchaseOutlays) : ''
                                                            }
                                                            fullWidth
                                                            InputProps={{
                                                                className: classes.budgetInputInput,
                                                                readOnly: true,
                                                                startAdornment: <InputAdornment
                                                                    position="start">&pound;</InputAdornment>,
                                                            }}
                                                            variant="outlined"
                                                            className={classes.budgetInput}
                                                        />
                                                    </div>
                                                    <div>
                                                        <TextField
                                                            id="surplus_from_sale"
                                                            label="Surplus from Sale"
                                                            value={
                                                                context.budgetPlannerData.saleBalance ? (new Intl.NumberFormat('en-GB', {
                                                                    style: 'decimal',
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                })).format(context.budgetPlannerData.saleBalance) : ''
                                                            }
                                                            fullWidth
                                                            InputProps={{
                                                                className: classes.budgetInputInput,
                                                                readOnly: true,
                                                                startAdornment: <InputAdornment
                                                                    position="start">&pound;</InputAdornment>,
                                                            }}
                                                            variant="outlined"
                                                            className={classes.budgetInput}
                                                        />
                                                    </div>
                                                    <div>
                                                        <TextField
                                                            id="formData.additional_cash"
                                                            label="Balance from you"
                                                            onChange={onFormChange}
                                                            value={
                                                                (new Intl.NumberFormat('en-GB', {
                                                                    style: 'decimal',
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0
                                                                })).format(context.budgetPlannerData.formData.additional_cash)
                                                            }
                                                            fullWidth
                                                            InputProps={{
                                                                className: classes.budgetInputInput,
                                                                startAdornment: <InputAdornment
                                                                    position="start">&pound;</InputAdornment>,
                                                            }}
                                                            variant="outlined"
                                                            className={classes.budgetInput}
                                                        />
                                                    </div>
                                                    <div>
                                                        <div className={classes.totalsBox}>
                                                            <Typography className={classes.totalsBoxWhite}>
                                                                {context.budgetPlannerData.purchaseBalance < 0 ? <>You need to find: </> : <>You have a surplus of: </>}
                                                            </Typography>
                                                            <Typography className={classes.totalsBoxBlue}>
                                                                {context.outputCurrency(context.budgetPlannerData.purchaseBalanceAbs)}
                                                            </Typography>
                                                        </div>
                                                    </div>
                                                </form>
                                            </Paper>
                                        </Grid>
                                    </Grid>
                                    </div>
                                </>
                                }
                                {context.budgetPlannerData.feeTotals !== undefined && !context.budgetPlannerData.doSale &&
                                <>
                                    <div className={classes.formContainer}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={6}>
                                                <Paper elevation={3} variant="outlined" className={classes.infoBox}>
                                                    <form className={classes.root} noValidate autoComplete="off">
                                                        <div>
                                                            <TextField
                                                                id="formData.formPurchasePrice"
                                                                onChange={onFormChange}
                                                                label="Purchase Price"
                                                                value={
                                                                    context.budgetPlannerData.formData.formPurchasePrice ? (new Intl.NumberFormat('en-GB', {
                                                                        style: 'decimal',
                                                                        minimumFractionDigits: 0,
                                                                        maximumFractionDigits: 0
                                                                    })).format(context.budgetPlannerData.formData.formPurchasePrice) : ''
                                                                }
                                                                fullWidth
                                                                InputProps={{
                                                                    className: classes.budgetInputInput,
                                                                    startAdornment: <InputAdornment
                                                                        position="start">&pound;</InputAdornment>,
                                                                }}
                                                                variant="outlined"
                                                                className={classes.budgetInput}
                                                            />
                                                        </div>
                                                        {
                                                            context.budgetPlannerData.formData.is_fhf !== 0 ?
                                                                <div>
                                                                    <TextField
                                                                        id="formData.first_home_fund"
                                                                        onChange={onFormChange}
                                                                        label="First Home Fund"
                                                                        value={
                                                                            context.budgetPlannerData.formData.first_home_fund ? (new Intl.NumberFormat('en-GB', {
                                                                                style: 'decimal',
                                                                                minimumFractionDigits: 0,
                                                                                maximumFractionDigits: 0
                                                                            })).format(context.budgetPlannerData.formData.first_home_fund) : ''
                                                                        }
                                                                        fullWidth
                                                                        InputProps={{
                                                                            className: classes.budgetInputInput,
                                                                            startAdornment: <InputAdornment
                                                                                position="start">&pound;</InputAdornment>,
                                                                        }}
                                                                        variant="outlined"
                                                                        className={classes.budgetInput}
                                                                    />
                                                                </div> : <></>
                                                        }
                                                        <div>
                                                            <TextField
                                                                id="formData.mortgageLevel"
                                                                onChange={onFormChange}
                                                                label="Mortgage Required"
                                                                value={
                                                                    context.budgetPlannerData.formData.mortgageLevel ? (new Intl.NumberFormat('en-GB', {
                                                                        style: 'decimal',
                                                                        minimumFractionDigits: 0,
                                                                        maximumFractionDigits: 0
                                                                    })).format(context.budgetPlannerData.formData.mortgageLevel) : ''
                                                                }
                                                                fullWidth
                                                                InputProps={{
                                                                    className: classes.budgetInputInput,
                                                                    startAdornment: <InputAdornment
                                                                        position="start">&pound;</InputAdornment>,
                                                                }}
                                                                variant="outlined"
                                                                className={classes.budgetInput}
                                                            />
                                                        </div>
                                                        <div>
                                                            <TextField
                                                                id="purchase_fees"
                                                                label="Legal Fees"
                                                                value={
                                                                    context.budgetPlannerData.feeTotals.purchaseFees ? (new Intl.NumberFormat('en-GB', {
                                                                        style: 'decimal',
                                                                        minimumFractionDigits: 0,
                                                                        maximumFractionDigits: 0
                                                                    })).format(context.budgetPlannerData.feeTotals.purchaseFees) : ''
                                                                }
                                                                fullWidth
                                                                InputProps={{
                                                                    className: classes.budgetInputInput,
                                                                    readOnly: true,
                                                                    startAdornment: <InputAdornment
                                                                        position="start">&pound;</InputAdornment>,
                                                                }}
                                                                variant="outlined"
                                                                className={classes.budgetInput}
                                                            />
                                                        </div>
                                                        <div>
                                                            <TextField
                                                                id="purchase_outlays"
                                                                label="Legal Outlays"
                                                                value={
                                                                    context.budgetPlannerData.feeTotals.purchaseOutlays ? (new Intl.NumberFormat('en-GB', {
                                                                        style: 'decimal',
                                                                        minimumFractionDigits: 0,
                                                                        maximumFractionDigits: 0
                                                                    })).format(context.budgetPlannerData.feeTotals.purchaseOutlays) : ''
                                                                }
                                                                fullWidth
                                                                InputProps={{
                                                                    className: classes.budgetInputInput,
                                                                    readOnly: true,
                                                                    startAdornment: <InputAdornment
                                                                        position="start">&pound;</InputAdornment>,
                                                                }}
                                                                variant="outlined"
                                                                className={classes.budgetInput}
                                                            />
                                                        </div>
                                                        <div>
                                                            <div className={classes.totalsBox}>
                                                                <Typography className={classes.totalsBoxWhite}>
                                                                    {context.budgetPlannerData.purchaseBalance < 0 ? <>You need to find: </> : <>You have a surplus of: </> }
                                                                </Typography>
                                                                <Typography className={classes.totalsBoxBlue}>
                                                                    {context.outputCurrency(context.budgetPlannerData.purchaseBalanceAbs)}
                                                                </Typography>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </Paper>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </>
                                }
                            </div>
                        </Fade>
                        <br/>
                        <Grid container  alignItems="center" justify="center" spacing={3}>
                            <Grid  item>
                            <Button

                                className={classes.gotoButton}
                                onClick={onResetPress}
                                startIcon={<Avatar className="AvatarCircle"><FontAwesomeIcon className="gotoButtonIcon" icon={faUndoAlt} /></Avatar>}
                                disabled={!context.doResetButton}
                            >
                                Reset
                            </Button>
                            <Button

                                className={classes.gotoButton}
                                onClick={doUpdatePress}
                                startIcon={<Avatar className="AvatarCircle"><FontAwesomeIcon className="gotoButtonIcon" icon={faSync} /></Avatar>}
                                disabled={!context.doUpdateButton}
                            >
                                Update Calculations
                            </Button>
                            <Button
                                href={apiUrl+'/fcase/'+context.pipData.fcase_id+'/budgetplanner/download'}
                                target="_blank"
                                className={classes.gotoButton}
                                startIcon={<Avatar className="AvatarCircle"><FontAwesomeIcon className="gotoButtonIcon" icon={faPoundSign} /></Avatar>}
                            >
                                Download Budgetplanner
                            </Button>
                            </Grid>
                        </Grid>





                    </CollapsableLightBlue>



                </Fragment>

            }
            </Container>
        </Fragment>

    );
}

export default MarketDataTable;